<template>
    <addDialog ref="addDialog"
               @event="addDialogEvent">
    </addDialog>
</template>
<script>
  import App from '../../util/comfun'
  import addDialog from '../components/traffic/addDialog'
  export default {
    components: {
      addDialog,
    },
    props:{
    },
    data () {
      return {

      }
    },
    methods:{
      addDialogEvent(e){
        if(e.act=='success'){
          return wx.miniProgram.navigateBack()
        }
        if(e.act=='close'){
          if('wxlite'==this.options.scene){//小程序来的返回
            return wx.miniProgram.navigateBack()
          }else{//网页跳转来的
            history.back()
          }
        }
      },
    },
    mounted(){
      try{
        this.options=JSON.parse(decodeURIComponent(decodeURIComponent(this.$route.params.options)))
        if(this.options.token){
          wxlite.setStorageSync('token',this.options.token)
        }
        console.log('this.options',this.options)
        //this.uid=this.options.uid
        this.$refs.addDialog.show(this.options.uid)
      }catch(e){}
    },
  }
</script>

<style>
    @import 'element-ui/lib/theme-chalk/display.css';
 .border{
     border: 1px solid #ccc;
     padding: 5px;
     border-radius: 5px;
     margin-right: 5px;
 }
 .el-switch__label{
     white-space:nowrap;
     color: #606266;
 }
 .el-switch__label.is-active{
     color: #606266;
 }
 .el-descriptions__header{
     margin-bottom: 10px;
 }
</style>


// WEBPACK FOOTER //
// src/pages/tools/down-traffic.vue